class PointsHeader {
  constructor(getText, theme) {
    this.getText = getText;
    this.theme = theme || {};
    this.container = document.createElement('div');
    this.points = 0;
    this.pendingPoints = 0;
    this.label = Pollfish.helper.json.reward_name || 'Points';
  }

  update(points, pendingPoints, label) {
    this.points = points;
    this.pendingPoints = pendingPoints;
    this.label = decodeURIComponent(label);
    this.render();
  }

  attachListeners() {
    if (this.hasAttachedListeners || !this.clickHandler) {
      return;
    }
    this.hasAttachedListeners = true;
    $('#wrapper').on('click tap', '#js-goto-points', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.clickHandler();
    });
  }

  onClick(callback) {
    this.clickHandler = callback;
  }

  render() {
    const { points, label, pendingPoints } = this;
    // const { getText } = this;
    const { backgroundColor } = this.theme;
    const logo = Pollfish.helper.json.theme_logo || null;
    this.container.innerHTML = `
      <header class="flex pd-sm" style="background-color: ${backgroundColor ||
        '#fff'}">
        <section class="flex flex-1 container flex-align-items--center">
          <div class="flex-1">
            ${
              logo
                ? `<img src=${logo} style="height: 25px;display: block;" />`
                : ''
            }
          </div>
          <div class="flex flex-align-items--center">
            ${
              pendingPoints > 0
                ? '<span class="badge margin-xxs-horizontal"></span>'
                : ''
            }
            <button id="js-goto-points" class="btn btn-primary btn-label text-capitalize">
              ${points} ${label}
            </button>
            <div id="js-select-sorting" class="margin-xxs-left"></div>
          </div>
        </section>
      </header>
    `;

    this.attachListeners();

    return this.container;
  }
}

export default PointsHeader;
